import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LanguageService } from '../../services/i18n/language';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contacts',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.scss'
})
export class ContactsComponent implements OnInit, OnDestroy {
  readonly contactPhone = '+7 707 888 00 54';
  readonly contactPhoneHref = 'tel:+77078880054';
  /** WhatsApp с готовым текстом — клиенту не нужно придумывать первое сообщение. */
  get contactWhatsappHref(): string {
    const value = this.languageService.translate('header.whatsappMessage');
    const text = value && value !== 'header.whatsappMessage' ? value : 'Здравствуйте! У меня вопрос по Bilload';
    return 'https://wa.me/77078880054?text=' + encodeURIComponent(text);
  }
  readonly contactEmail = 'info@bilload.com';
  readonly companyName = 'ТОО «Bilload»';

  titleText = 'Контакты';
  subtitleText = 'Свяжитесь с нами любым удобным способом';
  phoneLabel = 'Телефон';
  whatsappLabel = 'Написать в WhatsApp';
  emailLabel = 'Email';

  private subscriptions = new Subscription();

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.updateTranslations();
    this.subscriptions.add(
      this.languageService.getTranslations().subscribe(() => {
        this.updateTranslations();
        this.cdr.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private t(key: string, fallback: string): string {
    return this.languageService.translate(key) || fallback;
  }

  private updateTranslations(): void {
    this.titleText = this.t('contacts.title', 'Контакты');
    this.subtitleText = this.t('contacts.subtitle', 'Свяжитесь с нами любым удобным способом');
    this.phoneLabel = this.t('contacts.phoneLabel', 'Телефон');
    this.whatsappLabel = this.t('contacts.whatsappLabel', 'Написать в WhatsApp');
    this.emailLabel = this.t('contacts.emailLabel', 'Email');
  }
}
